/**
 * HomeLayoutTopicFocus - Topic-focused homepage layout wrapper
 * Applies CSS class for topic-focused styling; children handle article rendering
 */
import React from 'react';

const HomeLayoutTopicFocus = ({ children }) => {
    return (
        <div className="home-layout home-layout--topic-focus">
            <div className="home-layout__body">
                {children}
            </div>
        </div>
    );
};

export default HomeLayoutTopicFocus;
